import { compsInformationMappings } from 'helpers/comps/comp_info_mappings';
import { filterByTab } from '../custom_fields/helpers';
import { filterLiteCrmContactColumns, filterLiteCrmContactColumnsFromInfoMapping } from '../helpers';
import { filterSchemas } from 'bundles/apex/custom_fields/filters/helpers';

import type { CustomFieldSchema } from 'bundles/crm/types';

export function getCurrentColumnProps(
  currentColumns,
  edgeCrm: boolean,
  customFieldSchemas: CustomFieldSchema[],
  currentTab: string,
) {
  const informationMappings = { ...compsInformationMappings };

  if (edgeCrm) {
    filterLiteCrmContactColumnsFromInfoMapping(informationMappings);
    currentColumns = filterLiteCrmContactColumns(currentColumns);

    informationMappings.customFieldSchemas = {
      title: 'Custom Fields',
      key: 'customFieldSchemas',
      mappings: {}
    };

    filterLiteCrmContactColumnsFromInfoMapping(informationMappings);
    for (const customField of filterSchemas(customFieldSchemas, filterByTab(currentTab))) {
      informationMappings.customFieldSchemas.mappings[customField.slug] = customField.label;
    }
  }

  return {
    currentColumns,
    informationMappings,
  };
}
